import { SCHEDULE_TRIGGER_TIMES } from "@qw/qw-common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@qw/ui";

export interface ScheduleTimeSelectProps {
  value: string | undefined;
  onChange: (time: string) => void;
  disabled: boolean;
  label: string;
}

export const ScheduleTimeSelect = ({ value, onChange, disabled, label }: ScheduleTimeSelectProps) => (
  <Select value={value} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger aria-label={label} className="w-48 bg-background">
      <SelectValue placeholder="Select a time" />
    </SelectTrigger>
    <SelectContent>
      {SCHEDULE_TRIGGER_TIMES.map((time) => (
        <SelectItem key={time} value={time}>
          {time}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
